import * as React from 'react';
import { useDispatch } from 'umi';

import { LeadModel } from '@/typings/models/Lead';
import styles from '@/components/Lead/index.less';
import ProductGroupSelect from '@/components/Filters/ProductGroupSelect';
import { F } from '@/utils/intl';

export const LeadProductGroupPresentation = ({lead}: {lead: LeadModel}) => {
  if (!lead?.product_group) return null
  return lead.product_group.label
}

const LeadProductGroup = ({ lead, isTable, readonly }: { lead: LeadModel; isTable?: boolean; readonly?: boolean }) => {
  const dispatch = useDispatch();
  const onLeadProductGroupChange = (newProductGroupId: string) => {
    dispatch({
      type: 'leads/edit',
      payload: {
        product_group_id: newProductGroupId,
        leadId: lead.id,
      },
    });
  };

  if (readonly)
    return <LeadProductGroupPresentation lead={lead} />;


  const selectProps = { bordered: false, allowClear: false, variant: 'borderless' as const };
  return (
    <ProductGroupSelect
      type="dropdown"
      placeholder={<F id={'entity.product_group.singular'} defaultMessage={'Product Group'} />}
      className={styles.leadProductGroupSelectContainer}
      selectProps={selectProps}
      filterMode={'select'}
      hasCreate
      onChange={onLeadProductGroupChange}
      value={lead?.product_group?.uuid}
    />
  );
};

export default LeadProductGroup
